// Third Party
import { NextPage } from 'next';
import { useSession } from 'next-auth/react';

// UI
import { PublicLayout } from '@layouts/public-layout';
import { RequestACall } from '@pages-components/request-a-call';

/**
 * This page is visible to unauthenticated and authenticated users
 */
const RequestACallPage: NextPage = () => {
  const { data: session, status } = useSession();

  return (
    <PublicLayout
      session={session}
      loadingSession={status === 'loading'}
      canonicalUrl={''}
      pageTitle="Request A Call | Savvy"
      pageDescription="Request a call from a Savvy agent"
    >
      <RequestACall />
    </PublicLayout>
  );
};

export default RequestACallPage;
